import classNames from "classnames";
import { CSSProperties } from "react";
import Bar from "../Bar/Bar";
import Typography from "../Typography/Typography";
import "./StackedBar.scss";

export type StackedBarProps = {
	title: string;
	maxValue: number;
	bars: {
		value: number;
		formatFunction?: Function;
	}[];
	className?: string;
};

const StackedBar = ({ title, maxValue, bars, className }: StackedBarProps) => {
	let barsSum = 0;
	bars.forEach((bar) => {
		barsSum += bar.value;
	});
	const width = (barsSum * 100) / maxValue;

	return (
		<figure className="stacked-bar-container">
			<div
				className={classNames("stacked-bar", className)}
				style={{ "--stacked-bar-ratio": `${width}%` } as CSSProperties}>
				{bars.map((bar, index) => {
					const barWidth = (bar.value * 100) / maxValue;
					return (
						<Bar
							key={index}
							label={
								bar.formatFunction
									? bar.formatFunction(bar.value)
									: bar.value.toString()
							}
							className={classNames(
								"stacked-bar__bar",
								index === 0 ? "bar--baseline" : "bar--avoidableWaste",
							)}
							style={{ "--bar-width": `${barWidth}%` } as CSSProperties}
						/>
					);
				})}
			</div>
			<Typography as="figcaption" className="stacked-bar__title">
				{title}
			</Typography>
		</figure>
	);
};

export default StackedBar;
